import React from 'react';
export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost';
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  children,
  className = '',
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'px-6 py-3 rounded-xl font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-40 disabled:cursor-not-allowed';
  const getVariantStyles = () => {
    switch (variant) {
      case 'primary':
        return 'text-white hover:opacity-90 active:scale-[0.98]';
      case 'secondary':
        return 'bg-white text-[var(--nmhl-burgundy)] border-2 hover:bg-slate-50 active:scale-[0.98]';
      case 'ghost':
        return 'bg-transparent text-slate-700 hover:bg-slate-50 hover:text-slate-900 active:scale-[0.98]';
      default:
        return '';
    }
  };
  const getVariantStyle = () => {
    switch (variant) {
      case 'primary':
        return {
          backgroundColor: 'var(--nmhl-burgundy)',
          '--tw-ring-color': 'var(--nmhl-burgundy)'
        } as React.CSSProperties;
      case 'secondary':
        return {
          borderColor: 'var(--nmhl-burgundy)',
          '--tw-ring-color': 'var(--nmhl-burgundy)'
        } as React.CSSProperties;
      default:
        return {};
    }
  };
  return <button className={`${baseStyles} ${getVariantStyles()} ${className}`} style={getVariantStyle()} disabled={disabled} {...props} data-id="element-330">
      {children}
    </button>;
}